import React from "react";
import { formatPrice } from "../../../../../utils/price.utils";
import { LazyLoadImage } from "react-lazy-load-image-component";

const CancelOrderItems = ({ items }) => {

    return (
        <div className="cancel-order-details">

            <h3 style={{ borderBottom: "1px solid #e4e4e4", padding: "10px 0" }}>
                Order Details
            </h3>

            {items.map(item => (

                <div className="order-box" key={item.id}>

                    <div className="order-info cancel-products-box">

                        <p><b>{item.product_name}</b></p>
                        <p><b>Qty.</b> : {item.quantity}</p>
                        <p><b>Size</b> : {item.size}</p>
                        <p><b>Color</b> : {item.color}</p>
                        <p><b>Selling Price</b> : {formatPrice(item.selling_price)}</p>

                    </div>

                    <LazyLoadImage
                        className="img_cancel"
                        src={item.product_media}
                        alt={item.product_name}
                        effect="blur"
                    />

                </div>

            ))}

        </div>
    );
};

export default CancelOrderItems;